// extracted by mini-css-extract-plugin
var _1 = "ProfileSettings_action__WMdNL";
var _2 = "ProfileSettings_actionsWrapper__Nbkjw";
var _3 = "ProfileSettings_avatarEdit__pRur3";
var _4 = "ProfileSettings_avatarImage__wyG48";
var _5 = "ProfileSettings_avatarText__e7L-T";
var _6 = "ProfileSettings_editButton__utSSQ";
var _7 = "ProfileSettings_iconEditButton__scX-C";
export { _1 as "action", _2 as "actionsWrapper", _3 as "avatarEdit", _4 as "avatarImage", _5 as "avatarText", _6 as "editButton", _7 as "iconEditButton" }
